module.exports = __webpack_public_path__ + "img/img1_9.436a0810.jpeg";